(function () {
  'use strict';

  var COOKIE_NAME = 'bionika_brand';
  // A storefront szűrő a `compatibility` metafieldre megy (nem a `brand`-re),
  // hogy egy termék BÁRMELYIK kompatibilis márkája alapján szűrhető legyen.
  // A Search & Discovery-ben a „Márka" facet forrása is a compatibility metafield.
  var FILTER_KEY = 'filter.p.m.custom.compatibility';
  var COOKIE_DAYS = 30;

  // A BIONIKA saját termékei (brand == 'BIONIKA' + 'BIONIKA Műszerek') MINDEN
  // globális márkaszűréskor jelenjenek meg. Ezeknek a `compatibility` metafieldje
  // tartalmazza az 'BIONIKA' értéket, ezért minden alkalmazott szűrőbe OR-ként
  // betesszük ezt is: a Shopify natív storefront-facet UGYANAZON kulcs több
  // értékét VAGY-kapcsolatként kezeli (compatibility=X ∨ compatibility=BIONIKA).
  // Ez a segéd-érték a facets.liquid-ben el van rejtve a szűrő-UI-ból.
  var ALWAYS_VALUE = 'BIONIKA';

  // A cookie-beli márkához tartozó szűrő-értékek: a kiválasztott márka + a mindig
  // megjelenő BIONIKA sentinel. Üres márkánál üres tömb (nincs szűrő).
  function desiredFilterValues(brand) {
    if (!brand) return [];
    if (brand === ALWAYS_VALUE) return [ALWAYS_VALUE];
    return [brand, ALWAYS_VALUE];
  }
  // Rá­teszi a szűrő-értékeket egy URLSearchParams-ra (előbb törli a régieket).
  function setFilterParams(params, brand) {
    params.delete(FILTER_KEY);
    desiredFilterValues(brand).forEach(function (v) { params.append(FILTER_KEY, v); });
  }
  // Halmaz-egyenlőség sorrend-függetlenül (a szűrő-értékek összevetéséhez).
  function sameValues(a, b) {
    if (a.length !== b.length) return false;
    var sa = a.slice().sort(), sb = b.slice().sort();
    for (var i = 0; i < sa.length; i++) { if (sa[i] !== sb[i]) return false; }
    return true;
  }

  function getCookie(name) {
    var m = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return m ? decodeURIComponent(m[1]) : '';
  }
  function setCookie(name, value, days) {
    var d = new Date();
    d.setTime(d.getTime() + days * 86400000);
    document.cookie = name + '=' + encodeURIComponent(value) +
      '; expires=' + d.toUTCString() + '; path=/; samesite=lax';
  }
  function clearCookie(name) {
    document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/';
  }
  // BIONIKA (2026-10-08): a süti az egyetlen igazságforrás; a localStorage csak tükör (a lapok
  // közötti 'storage' eseményhez). Minden sütiírás után frissítjük, hogy ne térjen el.
  function mirrorBrand(value) {
    try { if (value) localStorage.setItem(COOKIE_NAME, value); else localStorage.removeItem(COOKIE_NAME); } catch (e) {}
  }

  // ── Márkanév-kanonizálás ─────────────────────────────────────────────────────
  // A cookie-ba több forrás is írhat (topbar-picker, compatible-oldal, MENÜ-cím a
  // syspick-ből). A menü-címek betűkódos toldalékot hordanak (pl. „Anthogyr®
  // Axiom® (AG)"), a termékek custom.compatibility metamezője viszont kód NÉLKÜLI
  // neveket („Anthogyr® Axiom®") — a kódos érték szűrőként 0 találatot ad.
  // Ez a függvény bármilyen bejövő nevet a TÉNYLEGES metafield-értékkészletre
  // (MP_COMPAT, a picker térképe) igazít. Ha nincs egyértelmű egyezés, a nevet
  // változatlanul hagyja.
  function canonNorm(s) {
    return String(s || '').toLowerCase().replace(/\([^)]*\)/g, '').replace(/[^a-z0-9]+/g, '');
  }
  function canonicalBrand(name) {
    if (!name) return name;
    var C = window.MP_COMPAT;
    if (!C) return name;
    var vals = [], seen = {};
    for (var k in C) { var v = C[k]; if (v && !seen[v]) { seen[v] = 1; vals.push(v); } }
    if (seen[name]) return name;                       // pontos egyezés → már kanonikus
    var n = canonNorm(name);
    if (!n) return name;
    // 1) normalizált egyezés (kód-toldalék és írásjelek nélkül)
    var hit = null, hits = 0;
    for (var i = 0; i < vals.length; i++) {
      if (canonNorm(vals[i]) === n) { hit = vals[i]; hits++; }
    }
    if (hits === 1) return hit;
    if (hits > 1) return name;                         // kétértelmű → nem nyúlunk hozzá
    // 2) tartalék: PONTOSAN EGY érték végződik a névre (pl. „iSy®" → „CAMLOG® iSy®")
    if (n.length >= 3) {
      hit = null; hits = 0;
      for (var j = 0; j < vals.length; j++) {
        var vn = canonNorm(vals[j]);
        if (vn.length > n.length && vn.slice(-n.length) === n) { hit = vals[j]; hits++; }
      }
      if (hits === 1) return hit;
    }
    // 3) tartalék: PONTOSAN EGY (leghosszabb) érték a név ELEJE (pl. a menü-cím
    //    bővebb a metafield-értéknél: „OT Medical® OT-F1" → „OT Medical®")
    hit = null; hits = 0;
    var bestLen = 0;
    for (var p = 0; p < vals.length; p++) {
      var pn = canonNorm(vals[p]);
      if (pn.length >= 5 && pn.length < n.length && n.slice(0, pn.length) === pn) {
        if (pn.length > bestLen) { bestLen = pn.length; hit = vals[p]; hits = 1; }
        else if (pn.length === bestLen) { hits++; }
      }
    }
    if (hits === 1 && hit) return hit;
    return name;
  }

  // Brand-független kollekciók (titán hálók, csontpótlás, általános műszerek stb.):
  // ezekre NEM alkalmazzuk a brand-szűrőt, mert nem rendszer-specifikusak.
  // A listát a brand-compat-groups.liquid → window.BIONIKA_BRAND_EXEMPT adja.
  function exemptHandles() {
    return (window.BIONIKA_BRAND_EXEMPT || []).map(function (h) {
      return String(h).trim().toLowerCase();
    });
  }
  function collectionHandle(pathname) {
    var m = pathname.match(/^\/collections\/([^\/\?#]+)/);
    return m ? decodeURIComponent(m[1]).toLowerCase() : '';
  }
  function isExempt(pathname) {
    var h = collectionHandle(pathname);
    if (!h) return false;
    return exemptHandles().indexOf(h) !== -1;
  }

  // Engedélyezett (szűrhető) kollekciók: a kevert márkájú prosztetikai
  // komponens-kategóriák (felepitmenyek-sub/full). A brand-szűrő CSAK ezeken
  // és a keresési oldalon hat. A BIONIKA saját rendszerek/vonalak, az egy konkrét
  // kompatibilis márka oldalai és a nem-kompatibilis kategóriák NEM szűrődnek.
  // A listát a brand-compat-groups.liquid → window.BIONIKA_BRAND_FILTERABLE adja.
  function filterableHandles() {
    return (window.BIONIKA_BRAND_FILTERABLE || []).map(function (h) {
      return String(h).trim().toLowerCase();
    });
  }
  // Pontos cikkszám/UDI keresés (≥9 számjegy, a szeparátorokat leszámítva): egy kód
  // eleve márka-specifikus, ezért ilyenkor NEM tesszük rá a globális márkaszűrőt —
  // különben a más márkájú termék kimaradna a találatokból (pl. 555.143.033.020).
  function qIsCode(q) {
    return String(q || '').replace(/[^0-9]/g, '').length >= 9;
  }
  // BIONIKA (2026-09-29): ha a keresőszó egy MÁSIK gyártót/rendszert nevez meg, mint a
  // globálisan kijelölt márka (pl. kijelölve Nobel®, keresés: „straumann abutment"), a
  // látogató szándéka egyértelmű → NEM tesszük rá a márkaszűrőt, különben a keresett
  // márka termékei kimaradnának. A kifejezés-térkép a BNK_SYSTEMS-ből (g=gyártó, m=modell,
  // v=szűrő-érték) épül; csak az EGY gyártóhoz köthető szavak számítanak márka-szónak.
  var BRAND_STOP = ('standard internal conical narrow regular wide platform screw vent tapered dental ' +
    'implant implants implantatum system systems rendszer short mini level bone plus connection ' +
    'abutment hex active line group full form root direct select parallel max easy tri ace ' +
    'interactive vital legacy seven bio one').split(' ');
  var brandTerms = null;
  function bnkTok(s) {
    return String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '')
      .replace(/[®™*]/g, ' ').split(/[^a-z0-9]+/).filter(function (w) { return w.length >= 3; });
  }
  function getBrandTerms() {
    if (brandTerms) return brandTerms;
    var S = window.BNK_SYSTEMS;
    if (!S || !S.length) return {};
    var map = {};                                          // szó → { g: {gyártók}, v: {értékek} }
    S.forEach(function (s) {
      if (!s || !s.v || /^bionika/i.test(s.g || '')) return;
      bnkTok((s.g || '') + ' ' + (s.m || '') + ' ' + s.v).forEach(function (w) {
        if (BRAND_STOP.indexOf(w) !== -1 || /^[0-9]+$/.test(w)) return;
        var e = map[w] || (map[w] = { g: {}, v: {} });
        e.g[s.g] = 1; e.v[s.v] = 1;
      });
    });
    brandTerms = {};
    for (var w in map) { if (Object.keys(map[w].g).length === 1) brandTerms[w] = map[w].v; }
    return brandTerms;
  }
  function qMentionsOtherBrand(q) {
    var brand = getCookie(COOKIE_NAME);
    if (!brand || !q) return false;
    var T = getBrandTerms();
    return bnkTok(q).some(function (w) { return T[w] && !T[w][brand]; });
  }
  // Keresés, amire a globális márkaszűrő NEM kerül rá: cikkszám vagy más márka neve.
  function qSkipsBrand(q) { return qIsCode(q) || qMentionsOtherBrand(q); }
  function isCodeSearch(search) {
    try { return qSkipsBrand(new URLSearchParams(search || '').get('q') || ''); }
    catch (e) { return false; }
  }
  function isFilterable(pathname, search) {
    if (/^\/search(\/|$|\?)/.test(pathname)) {
      // bnk_nofilter=1: a keresőoldali 0-találatos brand-szűrő fallback tette ki
      // (semantic-search.js) — ilyenkor NEM tesszük vissza a compatibility-szűrőt.
      try { if (new URLSearchParams(search || '').get('bnk_nofilter')) return false; } catch (e) {}
      return !isCodeSearch(search);
    }
    var h = collectionHandle(pathname);
    if (!h) return false;
    return filterableHandles().indexOf(h) !== -1;
  }

  function shouldRewrite(href) {
    if (!href) return false;
    try {
      var url = new URL(href, location.origin);
      if (url.origin !== location.origin) return false;
      // Csak kollekció + keresési URL-eket írunk át.
      // Termékoldal, account, blog, cart → nem szűrjük brand-re.
      if (!/^\/(collections|search)(\/|$|\?)/.test(url.pathname)) return false;
      // Csak az engedélyezett (kevert márkájú) kollekciókat / keresést írjuk át.
      if (!isFilterable(url.pathname, url.search)) return false;
      return true;
    } catch (e) {
      return false;
    }
  }

  // BIONIKA 2026-10-08: kivalasztott markanal a geometria-kollekcio (pl. Multi-unit fejek)
  // helyett a marka sajat kollekciojat nyitjuk meg az alkategoria-szurovel. A terkepek:
  // BNK_SUBCAT_FACET (kollekcio -> "kulcs|ertek") es BNK_BRAND_SYSTEMS / BNK_BRAND_URL_EXTRA
  // (marka -> kollekcio, ugyanugy normalizalva, mint a markavalasztoban).
  function bnorm(s) {
    s = String(s || '').replace(/\s*\([^)]*\)\s*$/, '').toLowerCase().replace(/^bionika\s+/, '');
    return s.replace(/[^a-z0-9]/g, '');
  }
  var brandUrlMap = null;
  function brandCollectionUrl(brand) {
    if (!brandUrlMap) {
      brandUrlMap = {};
      (window.BNK_BRAND_SYSTEMS || []).forEach(function (e) {
        if (!e || !e.t || !e.u) return;
        var k = bnorm(e.t);
        if (k && !brandUrlMap[k]) brandUrlMap[k] = e.u;
      });
      var ex = window.BNK_BRAND_URL_EXTRA || {};
      Object.keys(ex).forEach(function (b) { var k = bnorm(b); if (k) brandUrlMap[k] = ex[b]; });
    }
    return brandUrlMap[bnorm(brand)] || '';
  }
  function brandSubcatUrl(url) {
    var brand = getCookie(COOKIE_NAME);
    if (!brand || brand === ALWAYS_VALUE) return null;
    var map = window.BNK_SUBCAT_FACET;
    var h = collectionHandle(url.pathname);
    if (!map || !h || !map[h]) return null;
    // Mar szurt (pl. meretre) link: hagyjuk a regi viselkedest.
    var extra = false;
    url.searchParams.forEach(function (v, k) { if (k !== FILTER_KEY && k.indexOf('filter.') === 0) extra = true; });
    if (extra) return null;
    var target = brandCollectionUrl(brand);
    if (!target) return null;
    var pair = String(map[h]).split('|');
    var out = new URL(target, location.origin);
    if (collectionHandle(out.pathname) === h) return null;
    out = window.BnkSubcatTarget ? window.BnkSubcatTarget(out, pair, brand) : out;
    return out;
  }

  function applyFilterToLinks() {
    var brand = getCookie(COOKIE_NAME);
    var links = document.querySelectorAll('a[href]');
    for (var i = 0; i < links.length; i++) {
      var a = links[i];
      var sub = brandSubcatUrl(new URL(a.href, location.origin));
      if (sub) {
        if (!a.hasAttribute('data-bnk-orig-href')) a.setAttribute('data-bnk-orig-href', a.getAttribute('href'));
        a.href = sub.toString();
        continue;
      }
      if (a.hasAttribute('data-bnk-orig-href')) {
        a.setAttribute('href', a.getAttribute('data-bnk-orig-href'));
        a.removeAttribute('data-bnk-orig-href');
      }
      if (!shouldRewrite(a.href)) continue;
      var url = new URL(a.href, location.origin);
      if (brand) {
        setFilterParams(url.searchParams, brand);
      } else {
        url.searchParams.delete(FILTER_KEY);
      }
      a.href = url.toString();
    }
  }

  // Ha a globális PJAX navigáció elérhető, a márkaszűrő URL-szinkronja is
  // részleges tartalomcserével történjen. A location.replace csak biztonsági
  // tartalék régebbi böngészőre vagy hálózati/PJAX hibára.
  function replaceCurrentPage(url) {
    if (window.BionikaPjax && typeof window.BionikaPjax.navigate === 'function') {
      window.BionikaPjax.navigate(url.toString(), { replace: true, keepScroll: true });
      return;
    }
    location.replace(url.toString());
  }

  function syncCurrentPage() {
    if (!/^\/(collections|search)(\/|$)/.test(location.pathname)) return;
    var brand = getCookie(COOKIE_NAME);
    var current = new URL(location.href);
    var have = current.searchParams.getAll(FILTER_KEY);

    // Nem engedélyezett kollekció (vagy kód-keresés): soha ne legyen rajta a brand-szűrő.
    if (!isFilterable(location.pathname, location.search)) {
      if (have.length) {
        current.searchParams.delete(FILTER_KEY);
        replaceCurrentPage(current);
      }
      return;
    }

    // A kívánt szűrő-értékek: a márka + a BIONIKA sentinel (vagy üres). Ha az URL
    // már pontosan ezeket tartalmazza, nem töltünk újra.
    var want = desiredFilterValues(brand);
    if (!sameValues(have, want)) {
      setFilterParams(current.searchParams, brand);
      replaceCurrentPage(current);
    }
  }

  function getLineForBrand(brand) {
    if (!brand) return '';
    var map = window.BIONIKA_BRAND_TO_LINE || {};
    return map[brand] || '';
  }

  function updateHeaderUI() {
    var brand = getCookie(COOKIE_NAME);
    var label = document.querySelector('[data-brand-context-value]');
    var btn   = document.querySelector('[data-brand-context-btn]');
    var clear = document.querySelector('[data-brand-context-clear]');
    var hint  = document.querySelector('[data-brand-context-line-hint]');

    if (label) label.textContent = brand || 'Összes rendszer';

    // Show line-hint if the selected brand belongs to a compat group
    var line = getLineForBrand(brand);
    if (hint) {
      if (brand && line && line !== brand && ('BIONIKA ' + line) !== brand) {
        hint.textContent = '(= ' + line + ' vonal)';
        hint.hidden = false;
      } else {
        hint.textContent = '';
        hint.hidden = true;
      }
    }

    if (btn) {
      if (brand) btn.classList.add('brand-context__btn--filtered');
      else btn.classList.remove('brand-context__btn--filtered');
    }
    if (clear) clear.hidden = !brand;

    // Mark active in picker
    var items = document.querySelectorAll('[data-brand-pick]');
    for (var i = 0; i < items.length; i++) {
      var b = items[i].getAttribute('data-brand-pick');
      items[i].classList.toggle('is-active', !!brand && b === brand);
    }
  }

  function applyAll() {
    applyFilterToLinks();
    updateHeaderUI();
  }

  // Publikus API
  window.BionikaBrand = {
    get: function () { return getCookie(COOKIE_NAME); },
    // opts.noSync (2026-10-09): az aktuális oldal tartalmát NEM tölti újra (márka-oldal automatikus szinkronja —
    // ott a tartalom eleve az adott rendszeré, az újratöltés csak elrendezés-ugrást okozott).
    set: function (value, opts) {
      value = canonicalBrand(value);
      setCookie(COOKIE_NAME, value, COOKIE_DAYS);
      mirrorBrand(value);
      applyAll();
      document.dispatchEvent(new CustomEvent('bionika:brand-changed', { detail: { brand: value } }));
      if (!(opts && opts.noSync)) syncCurrentPage();
    },
    clear: function () {
      clearCookie(COOKIE_NAME);
      mirrorBrand('');
      applyAll();
      document.dispatchEvent(new CustomEvent('bionika:brand-changed', { detail: { brand: '' } }));
      syncCurrentPage();
    },
    // PJAX-integráció: tartalom-csere UTÁN újra rá kell tenni a szűrőt az ÚJ linkekre
    // (NEM hív syncCurrentPage-et → nincs reload).
    reapply: function () { applyAll(); },
    // Bármilyen (pl. menü-címből jövő) márkanév kanonizálása a metafield-értékkészletre.
    canonical: canonicalBrand,
    // A cél-URL-re ELŐRE ráteszi a kompatibilitás-szűrőt, amit a motor amúgy is rátenne,
    // hogy a PJAX rögtön a HELYES (szűrt) tartalmat kérje le → a motor nem tölt újra.
    decorateUrl: function (href) {
      try {
        var url = new URL(href, location.origin);
        if (!/^\/(collections|search)(\/|$|\?)/.test(url.pathname)) return url.toString();
        var sub = brandSubcatUrl(url);
        if (sub) return sub.toString();
        if (!isFilterable(url.pathname, url.search)) { url.searchParams.delete(FILTER_KEY); return url.toString(); }
        setFilterParams(url.searchParams, getCookie(COOKIE_NAME));
        return url.toString();
      } catch (e) { return href; }
    }
  };

  // Brand-pick gombok kezelése (a picker UI-ben)
  document.addEventListener('click', function (e) {
    var pick = e.target.closest('[data-brand-pick]');
    if (pick) {
      e.preventDefault();
      var name = pick.getAttribute('data-brand-pick');
      window.BionikaBrand.set(name);
      // Zárjuk be a pickert ha nyitva van
      var picker = document.querySelector('[data-brand-picker]');
      if (picker) picker.hidden = true;
      var btn = document.querySelector('[data-brand-context-btn]');
      if (btn) btn.setAttribute('aria-expanded', 'false');
      return;
    }
    var clear = e.target.closest('[data-brand-context-clear]');
    if (clear) {
      e.preventDefault();
      window.BionikaBrand.clear();
      return;
    }
  });

  // A KERESŐ-ŰRLAP beküldésekor már eleve rátesszük a compatibility szűrőt, hogy a
  // találati oldal EGYBŐL szűrve töltsön be. Enélkül a /search előbb szűretlenül
  // töltött, majd a syncCurrentPage újratöltötte a szűrővel → látható dupla-betöltés.
  // Csak a keresőmezős űrlapot érintjük (látható name="q"), a facet-szűrő űrlapot NEM.
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || form.tagName !== 'FORM') return;
    var action = form.getAttribute('action') || '';
    if (action.indexOf('/search') === -1) return;
    var q = form.querySelector('input[name="q"]');
    if (!q || q.type === 'hidden') return;               // facet-form (rejtett q) → kihagyjuk
    // Meglévő compatibility inputok eltávolítása (frissítés/törlés), majd az aktuális
    // szűrő-értékek (márka + BIONIKA sentinel) rejtett inputként rátétele.
    var old = form.querySelectorAll('input[name="' + FILTER_KEY + '"]');
    for (var j = 0; j < old.length; j++) old[j].parentNode.removeChild(old[j]);
    if (qSkipsBrand(q.value)) return;                         // pontos cikkszám → nincs márkaszűrő
    var brand = getCookie(COOKIE_NAME);
    desiredFilterValues(brand).forEach(function (v) {
      var hid = document.createElement('input');
      hid.type = 'hidden'; hid.name = FILTER_KEY; hid.value = v;
      form.appendChild(hid);
    });
  }, true);

  // BIONIKA (2026-09-29): a Márka (compatibility) facetben KÉZZEL választott rendszer
  // legyen az új globális márka. Korábban a süti a régi márkát tartotta, és minden
  // következő lapozás/navigáció/újratöltés visszakényszerítette → a látogató nem tudott
  // másik márkára szűrni. Egy kijelölt érték → az lesz a márka; üres → törlés;
  // több → a most bepipált. NEM hívunk syncCurrentPage-et (a Dawn facet-AJAX tölt).
  function adoptFacetBrand(values, justChecked) {
    var vals = values.filter(function (v) { return v && v !== ALWAYS_VALUE; });
    var cur = getCookie(COOKIE_NAME) || '';
    var next = vals.length === 1 ? vals[0]
      : !vals.length ? ''
      : (vals.indexOf(cur) !== -1 && !justChecked ? cur : (justChecked || vals[0]));
    if (next === cur) return;
    if (next) setCookie(COOKIE_NAME, next, COOKIE_DAYS); else clearCookie(COOKIE_NAME);
    mirrorBrand(next);
    applyAll();
    document.dispatchEvent(new CustomEvent('bionika:brand-changed', { detail: { brand: next, source: 'facet' } }));
  }
  document.addEventListener('change', function (e) {
    var inp = e.target;
    if (!inp || inp.name !== FILTER_KEY || inp.type !== 'checkbox') return;
    var form = inp.form || inp.closest('form');
    if (!form) return;
    var vals = [];
    var boxes = form.querySelectorAll('input[name="' + FILTER_KEY + '"]');
    for (var i = 0; i < boxes.length; i++) {
      if (boxes[i].checked && vals.indexOf(boxes[i].value) === -1) vals.push(boxes[i].value);
    }
    adoptFacetBrand(vals, inp.checked ? inp.value : '');
  }, true);
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('facet-remove a[href]');
    if (!a) return;
    try {
      var u = new URL(a.href, location.origin);
      if (location.search.indexOf('compatibility') === -1) return;
      adoptFacetBrand(u.searchParams.getAll(FILTER_KEY), '');
    } catch (err) {}
  }, true);

  // Cookie-gyógyítás: a korábban mentett (pl. menü-címből jövő, kód-toldalékos)
  // márkanevet a tényleges metafield-értékre igazítjuk. A cookie 30 napos, ezért
  // ez a már „kint lévő" hibás értékeket is helyrehozza; a syncCurrentPage ezután
  // a helyes szűrővel tölti (újra) az oldalt.
  (function healCookie() {
    var cur = getCookie(COOKIE_NAME);
    if (!cur) return;
    var canon = canonicalBrand(cur);
    if (canon !== cur) setCookie(COOKIE_NAME, canon, COOKIE_DAYS);
  })();

  // Indítás
  function initOnLoad() {
    applyAll();
    // Ha collection/search oldalon vagyunk és a cookie szerint van brand-context,
    // de az URL-ben nincs filter — automatikusan rátegyük. Ez fedi le a search-
    // form submitet (eddig hiányzott) is.
    syncCurrentPage();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initOnLoad);
  } else {
    initOnLoad();
  }

  // Storage event — ha másik tab-ben változik a brand, ez a tab is frissül
  // (cookie-knál nincs natív event, ezért localStorage tükör)
  // BIONIKA (2026-10-08): ha a süti máshol változott (másik lap, a picker közvetlen írása),
  // a nyitott lap is igazodjon: tükör + szűrők + 'bionika:brand-changed' (felirat-frissítés).
  var lastBrand = getCookie(COOKIE_NAME);
  mirrorBrand(lastBrand);
  document.addEventListener('bionika:brand-changed', function (e) {
    lastBrand = (e.detail && typeof e.detail.brand === 'string') ? e.detail.brand : getCookie(COOKIE_NAME);
    if (lastBrand !== getCookie(COOKIE_NAME)) lastBrand = getCookie(COOKIE_NAME);
    mirrorBrand(lastBrand);
  });
  function checkExternalBrandChange() {
    var cur = getCookie(COOKIE_NAME);
    if (cur === lastBrand) return;
    lastBrand = cur;
    mirrorBrand(cur);
    applyAll();
    document.dispatchEvent(new CustomEvent('bionika:brand-changed', { detail: { brand: cur, source: 'external' } }));
  }
  try {
    window.addEventListener('storage', function (e) {
      if (e.key === COOKIE_NAME) {
        var cur = getCookie(COOKIE_NAME);
        var changed = cur !== lastBrand;
        checkExternalBrandChange();
        if (changed) syncCurrentPage();
      }
    });
  } catch (e) { /* localStorage not available */ }
  document.addEventListener('visibilitychange', function () { if (!document.hidden) checkExternalBrandChange(); });
  window.addEventListener('focus', checkExternalBrandChange);
  window.addEventListener('pageshow', checkExternalBrandChange);

  // =============== SMART BANNER ===============
  // A brand-banner.liquid által renderelt sávot mutatja/elrejti.
  var BANNER_DISMISSED_KEY = 'bionika_banner_dismissed';

  function refreshBanner() {
    var banner = document.querySelector('[data-brand-banner]');
    if (!banner) return;
    var hasBrand = !!getCookie(COOKIE_NAME);
    var dismissed = getCookie(BANNER_DISMISSED_KEY) === '1';
    banner.hidden = hasBrand || dismissed;
  }

  document.addEventListener('click', function (e) {
    // "Select your implant system →" link → megnyitja az ÚJ márkaválasztó pickert
    var openLink = e.target.closest('[data-open-brand-picker]');
    if (openLink) {
      e.preventDefault();
      var mp = document.querySelector('[data-mp-open]');
      if (mp) { mp.click(); return; }
      var btn = document.querySelector('[data-brand-context-btn]');
      if (btn) btn.click();
      return;
    }
    // × dismiss gomb
    var dismiss = e.target.closest('[data-dismiss-brand-banner]');
    if (dismiss) {
      e.preventDefault();
      setCookie(BANNER_DISMISSED_KEY, '1', 90); // 90 napos
      refreshBanner();
      return;
    }
  });

  document.addEventListener('bionika:brand-changed', refreshBanner);

  // =============== BRAND-GROUPING ===============
  // Ha nincs brand-context és a látható termékkártyák 5+ különböző brandhez
  // tartoznak, a JS brand-szekciókra rendezi át a rácsot.

  var GROUPING_ATTR = 'data-brands';   // a .card-wrapper-en kell legyen
  var GRID_SELECTOR = '#product-grid, .product-grid';
  var MIN_BRANDS_FOR_GROUPING = 5;
  var MAX_CARDS_PER_BRAND = 5;

  function getCardBrands(card) {
    // A data-brands attribútum a kártyán VAGY egy leszármazottján lehet.
    var el = card.hasAttribute(GROUPING_ATTR) ? card : card.querySelector('[' + GROUPING_ATTR + ']');
    var raw = el ? (el.getAttribute(GROUPING_ATTR) || '') : '';
    if (!raw) return [];
    return raw.split('|').map(function (s) { return s.trim(); }).filter(Boolean);
  }

  // "Minden termék mutatása" választás kulcsa (oldal-handle szerint).
  function showAllKey() { return 'bnk_show_all_' + location.pathname; }

  // line → line_full (a chip-re kattintáskor ezzel szűrünk)
  function buildLineFullMap() {
    var map = {};
    (window.BIONIKA_COMPAT_GROUPS || []).forEach(function (g) { map[g.line] = g.line_full; });
    (window.BIONIKA_OTHER_LINES || []).forEach(function (l) { map[l.line] = l.line_full; });
    return map;
  }

  function groupGridByBrand() {
    // A régi, kompatibilis-CSOPORT alapú rács-választót az ÚJ topbar márkaválasztó
    // (brand-context-picker.liquid) váltja ki. Flaggel kikapcsolva; ha vissza
    // kell hozni, töröld a window.BIONIKA_DISABLE_GROUPING sort a compat-groups snippetből.
    if (window.BIONIKA_DISABLE_GROUPING) return;
    if (getCookie(COOKIE_NAME)) return;     // brand-context aktív → ne csoportosíts
    // "Show all" választás ezen az oldalon → nem csoportosítunk.
    try { if (sessionStorage.getItem(showAllKey()) === '1') return; } catch (e) {}

    var grid = document.querySelector(GRID_SELECTOR);
    if (!grid) return;
    if (grid.dataset.brandGrouped === '1') return;

    // A márka-darabszámokat a Shopify Brand FACET-ből olvassuk (sidebar szűrő),
    // mert az a TELJES kollekcióra ad pontos számokat és minden márkát — nem
    // csak az aktuális oldal termékeit, és nem rendel egy terméket egy line-hoz.
    var inputs = document.querySelectorAll(
      'input[name="' + FILTER_KEY + '"], input[name^="' + FILTER_KEY + '"]'
    );
    var byName = {};   // brandName → { count, pick }
    var order = [];
    function parseCount(text) {
      // az UTOLSÓ "(szám)" a label szövegében
      var matches = text.match(/\((\d[\d\s.,]*)\)/g);
      if (!matches || !matches.length) return null;
      return parseInt(matches[matches.length - 1].replace(/\D/g, ''), 10);
    }
    Array.prototype.forEach.call(inputs, function (inp) {
      if (inp.disabled) return;             // 0 találatú facet-érték → kihagyjuk
      var val = (inp.value || '').trim();
      if (!val) return;
      var label = inp.closest('label');
      if (!label && inp.id) label = document.querySelector('label[for="' + inp.id + '"]');
      var labelText = label ? label.textContent : '';
      var count = parseCount(labelText);
      if (!byName[val]) {
        byName[val] = { count: count, pick: val };
        order.push(val);
      } else if (count != null && (byName[val].count == null || count > byName[val].count)) {
        byName[val].count = count;          // dedup (mobil+desktop facet)
      }
    });

    if (order.length < MIN_BRANDS_FOR_GROUPING) return;   // kevés márka → nincs választó

    // Darabszám szerint csökkenően rendezünk (ahol nincs szám, a végére kerül).
    // ---- Csoportosítás Bionika line-ok szerint ----
    // A kompatibilis rendszerek ugyanazokra a termékekre szűrnek, mint a
    // hozzájuk tartozó Bionika line — ezért egy line = egy kártya, a
    // kompatibilis rendszerek alatta hint-ként. Ami egyik line-hoz sem tartozik,
    // az az "Other systems" szekcióba kerül.
    var compatLineMap = {};   // brand(lower) → line
    var lineFullMap = {};     // line → line_full
    var compatList = {};      // line → [compatible brand names]
    (window.BIONIKA_COMPAT_GROUPS || []).forEach(function (g) {
      lineFullMap[g.line] = g.line_full;
      compatLineMap[g.line.toLowerCase()] = g.line;
      compatLineMap[g.line_full.toLowerCase()] = g.line;
      compatList[g.line] = (g.compatible || []).slice();
      (g.compatible || []).forEach(function (b) { compatLineMap[b.toLowerCase()] = g.line; });
    });
    (window.BIONIKA_OTHER_LINES || []).forEach(function (l) {
      lineFullMap[l.line] = l.line_full;
      compatLineMap[l.line.toLowerCase()] = l.line;
      compatLineMap[l.line_full.toLowerCase()] = l.line;
    });

    var lineGroups = {};   // line → { count, pick, compat:[] }
    var lineOrder = [];
    var others = [];
    order.forEach(function (name) {
      var line = compatLineMap[name.toLowerCase()];
      if (line) {
        if (!lineGroups[line]) { lineGroups[line] = { count: null, pick: null, compat: [] }; lineOrder.push(line); }
        var lf = (lineFullMap[line] || '').toLowerCase();
        var isOwn = (name.toLowerCase() === lf) || (name.toLowerCase() === line.toLowerCase());
        if (isOwn) {
          if (byName[name].count != null) lineGroups[line].count = byName[name].count;
          lineGroups[line].pick = byName[name].pick;
        } else {
          lineGroups[line].compat.push(name);
          if (lineGroups[line].count == null && byName[name].count != null) lineGroups[line].count = byName[name].count;
          if (!lineGroups[line].pick) lineGroups[line].pick = byName[name].pick;
        }
      } else {
        others.push(name);
      }
    });
    lineOrder.sort(function (a, b) { return (lineGroups[b].count || 0) - (lineGroups[a].count || 0); });

    var wrapper = document.createElement('div');
    wrapper.className = 'brand-chooser';

    var head = document.createElement('div');
    head.className = 'brand-chooser__head';
    head.innerHTML =
      '<h2 class="brand-chooser__title">Válassza ki az implantátum-rendszerét</h2>' +
      '<p class="brand-chooser__sub">A kompatibilis rendszerek Bionika vonalak szerint csoportosítva. ' +
      'Válassza ki a rendszerét — vagy keressen rá lent.</p>' +
      '<div class="brand-chooser__search">' +
      '<input type="text" data-chooser-search placeholder="Rendszer keresése… pl. Nobel, Astra, Ankylos">' +
      '</div>';
    wrapper.appendChild(head);

    // --- Bionika line kártyák ---
    if (lineOrder.length) {
      var lineGrid = document.createElement('div');
      lineGrid.className = 'brand-chooser__grid brand-chooser__grid--lines';
      lineOrder.forEach(function (line) {
        var g = lineGroups[line];
        var a = document.createElement('a');
        a.className = 'brand-chooser__chip brand-chooser__chip--line';
        a.href = '#';
        if (g.pick) a.setAttribute('data-brand-pick', g.pick);
        // keresési kulcs: line név + minden kompatibilis név
        a.setAttribute('data-search', (line + ' ' + g.compat.join(' ')).toLowerCase());
        var countHtml = (g.count != null) ? '<span class="brand-chooser__count">' + g.count + '</span>' : '';
        var compatHint = g.compat.length
          ? '<span class="brand-chooser__compat">benne: ' +
              g.compat.slice(0, 3).map(escapeHtml).join(', ') +
              (g.compat.length > 3 ? ' +' + (g.compat.length - 3) : '') + '</span>'
          : '';
        a.innerHTML = '<span class="brand-chooser__line-row"><span class="brand-chooser__name">' +
          escapeHtml(line) + '</span>' + countHtml + '</span>' + compatHint;
        lineGrid.appendChild(a);
      });
      wrapper.appendChild(lineGrid);
    }

    // --- Egyéb rendszerek (nem tartoznak line-hoz) ---
    if (others.length) {
      var otherTitle = document.createElement('h3');
      otherTitle.className = 'brand-chooser__section-title';
      otherTitle.textContent = 'Egyéb kompatibilis rendszerek';
      wrapper.appendChild(otherTitle);

      var otherGrid = document.createElement('div');
      otherGrid.className = 'brand-chooser__grid';
      others.forEach(function (name) {
        var a = document.createElement('a');
        a.className = 'brand-chooser__chip';
        a.href = '#';
        a.setAttribute('data-brand-pick', byName[name].pick);
        a.setAttribute('data-search', name.toLowerCase());
        var countHtml = (byName[name].count != null)
          ? '<span class="brand-chooser__count">' + byName[name].count + '</span>' : '';
        a.innerHTML = '<span class="brand-chooser__name">' + escapeHtml(name) + '</span>' + countHtml;
        otherGrid.appendChild(a);
      });
      wrapper.appendChild(otherGrid);
    }

    var foot = document.createElement('div');
    foot.className = 'brand-chooser__foot';
    foot.innerHTML = '<button type="button" class="brand-chooser__showall" data-show-all>' +
      'Összes termék megjelenítése →</button>';
    wrapper.appendChild(foot);

    grid.dataset.brandGrouped = '1';
    grid.classList.add('bnk-hidden-grid');
    grid.style.display = 'none';
    // A választót a rács FÖLÉ szúrjuk, hogy biztosan ez legyen az első,
    // és ne az ömlesztett termékek alatt jelenjen meg.
    grid.parentNode.insertBefore(wrapper, grid);
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c];
    });
  }

  function undoGrouping() {
    var grid = document.querySelector(GRID_SELECTOR);
    var chooser = document.querySelector('.brand-chooser');
    var grouped = document.querySelector('.brand-groups');
    if (grid) {
      grid.classList.remove('bnk-hidden-grid');
      grid.style.display = '';
      delete grid.dataset.brandGrouped;
    }
    if (chooser) chooser.remove();
    if (grouped) grouped.remove();
  }

  // "Show all products anyway" gomb
  document.addEventListener('click', function (e) {
    var sa = e.target.closest('[data-show-all]');
    if (!sa) return;
    e.preventDefault();
    try { sessionStorage.setItem(showAllKey(), '1'); } catch (err) {}
    undoGrouping();
  });

  // Chooser kereső — élőben szűri a chipeket (line név + kompatibilis nevek alapján)
  document.addEventListener('input', function (e) {
    var inp = e.target.closest('[data-chooser-search]');
    if (!inp) return;
    var q = inp.value.trim().toLowerCase();
    var chooser = inp.closest('.brand-chooser');
    if (!chooser) return;
    chooser.querySelectorAll('.brand-chooser__chip').forEach(function (chip) {
      var key = chip.getAttribute('data-search') || chip.textContent.toLowerCase();
      chip.style.display = (!q || key.indexOf(q) !== -1) ? '' : 'none';
    });
    // Üres szekció-címeket/rácsokat elrejtjük
    chooser.querySelectorAll('.brand-chooser__grid').forEach(function (grid) {
      var anyVisible = Array.prototype.some.call(grid.children, function (c) {
        return c.style.display !== 'none';
      });
      grid.style.display = anyVisible ? '' : 'none';
      var prev = grid.previousElementSibling;
      if (prev && prev.classList.contains('brand-chooser__section-title')) {
        prev.style.display = anyVisible ? '' : 'none';
      }
    });
  });

  // =============== TERMÉKCÍM RÖVIDÍTÉS ===============
  // Ha van kiválasztott márka, a termékcímek elejéről levágjuk a márka-részt
  // (az első vesszőig), hogy a tényleges terméknév hosszabban látszódjon.
  // A márkát a top-bar kontextus úgyis jelzi.
  // Az összes ismert márkanév, HOSSZ szerint csökkenően rendezve, hogy a
  // leghosszabb illeszkedjen először (pl. "BIONIKA Actival" előbb mint "Actival").
  var brandNamesSorted = null;
  function getBrandNamesSorted() {
    if (brandNamesSorted) return brandNamesSorted;
    var map = window.BIONIKA_BRAND_TO_LINE || {};
    brandNamesSorted = Object.keys(map).filter(function (k) { return k && k.length >= 3; });
    brandNamesSorted.sort(function (a, b) { return b.length - a.length; });
    return brandNamesSorted;
  }
  function stripTitlePrefix(text) {
    // CSAK a konkrét, ismert márkanevet vágjuk le a cím ELEJÉRŐL — a geometriát soha.
    var lower = text.toLowerCase();
    var names = getBrandNamesSorted();
    for (var i = 0; i < names.length; i++) {
      var n = names[i];
      if (lower.indexOf(n.toLowerCase()) === 0) {
        var rest = text.slice(n.length);
        // a márka utáni elválasztó (vessző, kötőjel, szóköz) levágása
        rest = rest.replace(/^[\s,–—-]+/, '').trim();
        if (rest.length >= 3) return rest;
        return null;
      }
    }
    return null;
  }
  function applyTitleStripping() {
    var hasBrand = !!getCookie(COOKIE_NAME);
    var titles = document.querySelectorAll('.card__heading a, .card__heading');
    for (var i = 0; i < titles.length; i++) {
      var el = titles[i];
      // a .card__heading lehet hogy maga tartalmaz <a>-t — azt kezeljük, a wrappert kihagyjuk
      if (el.classList.contains('card__heading') && el.querySelector('a')) continue;
      var orig = el.getAttribute('data-orig-title');
      if (hasBrand) {
        if (orig === null) {
          orig = el.textContent.trim();
          el.setAttribute('data-orig-title', orig);
        }
        var stripped = stripTitlePrefix(orig);
        el.textContent = stripped || orig;
      } else if (orig !== null) {
        // nincs márka → állítsuk vissza az eredetit
        el.textContent = orig;
      }
    }
  }

  // Indítás
  function clearGroupingPending() {
    document.documentElement.classList.remove('bnk-grouping-pending');
  }
  function initGroupingForPage() {
    if (!/^\/(collections|search)/.test(location.pathname)) { clearGroupingPending(); return; }
    if (getCookie(COOKIE_NAME)) {
      undoGrouping();
      clearGroupingPending();
      applyTitleStripping();
      return;
    }
    groupGridByBrand();
    clearGroupingPending();
    applyTitleStripping();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      refreshBanner();
      initGroupingForPage();
    });
  } else {
    refreshBanner();
    initGroupingForPage();
  }

  // Brand changed → frissít
  document.addEventListener('bionika:brand-changed', function () {
    undoGrouping();
    if (!getCookie(COOKIE_NAME)) initGroupingForPage();
  });

  // =============== TERMÉKKÁRTYA TÍPUS-CÍMKE (kontextus-függő) ===============
  // A kártya kép jobb alsó sarkában lévő `.card-brand-type` a termék kompatibilis
  // márka-megnevezései (custom.brand LISTA = a márkaválasztó értékei) közül a
  // LEGRELEVÁNSABBAT mutatja (user kérése):
  //   1) ha csak egy van → az;
  //   2) ha több ÉS van kiválasztott globális márka (picker cookie) → amelyik megegyezik vele;
  //   3) egyébként a termék CÍME alapján a legjobban illeszkedő (név vagy betűkód);
  //   4) végül az első.
  // A bare 'BIONIKA' sentinel (mindig-megjelenő jelölő) nem valódi típus → kihagyva.
  function ct_norm(s) {
    return String(s || '').replace(/\([^)]*\)/g, '').toLowerCase().replace(/[^a-z0-9]/g, '');
  }
  function ct_bestByTitle(cands, title) {
    var t = String(title || '').toLowerCase();
    if (!t) return null;
    var best = null, bestScore = 0;
    cands.forEach(function (c) {
      var score = 0;
      // Zárójeles betűkód (pl. „(CA)", „(ST)") a címben.
      var codeM = c.match(/\(([^)]+)\)/);
      if (codeM && codeM[1]) {
        var code = codeM[1].toLowerCase();
        if (code.length >= 2 && t.indexOf(code) !== -1) score += code.length + 3;
      }
      // Szavak (márka/rendszer nevek) a címben.
      c.replace(/\([^)]*\)/g, ' ').replace(/[®™]/g, ' ').split(/\s+/).forEach(function (w) {
        w = w.toLowerCase().replace(/[^a-z0-9]/g, '');
        if (w.length >= 3 && t.indexOf(w) !== -1) score += w.length;
      });
      if (score > bestScore) { bestScore = score; best = c; }
    });
    return bestScore > 0 ? best : null;
  }
  function ct_pick(cands, selectedNorm, title) {
    if (!cands.length) return '';
    if (cands.length === 1) return cands[0];
    if (selectedNorm) {
      for (var i = 0; i < cands.length; i++) {
        if (ct_norm(cands[i]) === selectedNorm) return cands[i];
      }
    }
    return ct_bestByTitle(cands, title) || cands[0];
  }
  // A címke TELJESEN kiírva jelenik meg (nincs levágás). Alapból a kép jobb alsó
  // sarkában; ha a szöveg túl nagy területet takarna a képen (a képmagasság ~45%-ánál
  // több), a JS a kép ALÁ helyezi (--below, normál folyamban). A mérést csak akkor
  // végezzük, ha a megjelenített szöveg változott (teljesítmény + a MutationObserver
  // a beírások idejére le van kapcsolva → nincs végtelen ciklus).
  var CT_OBSERVER = null, ct_debounce = null;
  function ct_home(el) {
    if (!el._ctHome) { el._ctHome = el.parentNode; el._ctHomeNext = el.nextSibling; }
    el.classList.remove('card-brand-type--below');
    if (el.parentNode !== el._ctHome) el._ctHome.insertBefore(el, el._ctHomeNext);
  }
  function ct_belowContent(box) {
    // A kép-doboz (.card__inner) UTÁNI .card__content (a kép alatti tartalom).
    var c = box ? box.nextElementSibling : null;
    while (c && (' ' + c.className + ' ').indexOf('card__content') === -1) c = c.nextElementSibling;
    return c;
  }
  function ct_place(el, pick) {
    if (!pick) {
      ct_home(el);
      el.hidden = true; el.textContent = ''; el._ctText = null;
      return;
    }
    if (el._ctText === pick) { el.hidden = false; return; }   // nincs változás → nincs újramérés
    ct_home(el);                                              // mérés a kép-dobozon belüli állapotban
    el.hidden = false;
    el.setAttribute('title', pick);
    el.textContent = pick;
    var box = el._ctHome;
    var boxH = box ? box.clientHeight : 0;
    if (boxH > 20 && el.offsetHeight > boxH * 0.45) {
      var content = ct_belowContent(box);
      if (content) { el.classList.add('card-brand-type--below'); content.insertBefore(el, content.firstChild); }
    }
    el._ctText = pick;
  }

  function updateCardTypes() {
    if (CT_OBSERVER) CT_OBSERVER.disconnect();
    var els = document.querySelectorAll('[data-card-type]');
    var selectedNorm = ct_norm(getCookie(COOKIE_NAME));
    Array.prototype.forEach.call(els, function (el) {
      var cands;
      try { cands = JSON.parse(el.getAttribute('data-brands') || '[]'); } catch (e) { cands = []; }
      if (!Array.isArray(cands)) cands = [];
      var seen = {};
      cands = cands.map(function (s) { return String(s).trim(); })
        .filter(function (s) { return s && s !== 'BIONIKA' && !seen[s] && (seen[s] = 1); });
      ct_place(el, ct_pick(cands, selectedNorm, el.getAttribute('data-title')));
    });
    ct_observe();
  }
  function ct_observe() {
    if (typeof MutationObserver === 'undefined') return;
    var grid = document.querySelector('#ProductGridContainer') ||
               document.querySelector('#product-grid') ||
               document.querySelector('.product-grid');
    var target = grid ? (grid.parentNode || grid) : null;
    if (!target) return;
    if (!CT_OBSERVER) {
      CT_OBSERVER = new MutationObserver(function () {
        if (ct_debounce) return;
        ct_debounce = setTimeout(function () { ct_debounce = null; updateCardTypes(); }, 60);
      });
    }
    CT_OBSERVER.observe(target, { childList: true, subtree: true });
  }
  window.BionikaUpdateCardTypes = updateCardTypes;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateCardTypes);
  } else {
    updateCardTypes();
  }
  window.addEventListener('load', updateCardTypes);        // képek betöltése után újramérés
  document.addEventListener('bionika:brand-changed', updateCardTypes);
  // Átméretezéskor a sortördelés változhat → kényszerített újramérés.
  var ct_resizeT = null;
  window.addEventListener('resize', function () {
    if (ct_resizeT) return;
    ct_resizeT = setTimeout(function () {
      ct_resizeT = null;
      var els = document.querySelectorAll('[data-card-type]');
      Array.prototype.forEach.call(els, function (el) { el._ctText = null; });
      updateCardTypes();
    }, 200);
  });
})();
